<template>
  <CustomTitleBar title="动态" />
  <div class="page-content">
    <el-empty description="暂无数据" :image="require('@/assets/images/empty.png')" />
  </div>
</template>
<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";


onMounted(() => {
})
</script>
<style lang="scss" scoped>
.page-content {
  padding-top: 44px;
}
</style>
